// extracted by mini-css-extract-plugin
export default {"icon":"UserInfoIcons_icon__CuyMc","name":"UserInfoIcons_name__AzNzS","card":"UserInfoIcons_card__tCH-s"};